import { render, staticRenderFns } from "./facial-result.vue?vue&type=template&id=6cfe9f7f&scoped=true&"
import script from "./facial-result.vue?vue&type=script&lang=js&"
export * from "./facial-result.vue?vue&type=script&lang=js&"
import style0 from "./facial-result.vue?vue&type=style&index=0&id=6cfe9f7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe9f7f",
  null
  
)

export default component.exports